/* ==========================================================================
   ProductCardCirRxjs > Client > Prototype
   ========================================================================= */
/* Modules */
// const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
// const Tippy = require('popper.js/dist/popper').default;
// import Tippy from 'tippy.js';

const { Store } = require('@bluekiri/alexandria/helpers/state');

const ImageClient = require('@bluekiri/alexandria-contrib-components/components/image-rxjs/client/js');

const { types, actions } = require('./store/actions');
const { reducer } = require('./store/reducer');

const { initNav } = require('./nav');

const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            card: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            activeTab: tab => this.store.dispatch(actions.activeTab(tab)),
            disableTab: tab => this.store.dispatch(actions.disableTab(tab))
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Unsubscribe */
                this.unsubscribe();
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Destroy */
                /* image */
                if (this.image) this.image.actions.destroy();
                if (this.secondaryImage) this.secondaryImage.actions.destroy();

                /* Delete from DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean references */
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),
            activeTab: this.store.subscribe((state, action) => {
                if (action.type !== types.ACTIVE_TAB) return;

                const { css } = this.config;
                this.hooks.tabs[action.payload].classList.add(css.active);
                this.navItems[action.payload].element.classList.add(css.active);

                if (this.hooks.images[action.payload]) this.hooks.images[action.payload].classList.add(css.active);
            }),
            disableTab: this.store.subscribe((state, action) => {
                if (action.type !== types.DISABLE_TAB) return;

                const { css } = this.config;
                this.hooks.tabs[action.payload].classList.remove(css.active);
                this.navItems[action.payload].element.classList.remove(css.active);

                if (this.hooks.images[action.payload] && this.hooks.images[1])
                    this.hooks.images[action.payload].classList.remove(css.active);
            })
        };

        return this;
    },
    /* Subscribe */
    subscribe() {
        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {};

        return this;
    },
    /* Unsubscribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },

    start() {
        if (!this.config.start) return this;

        initNav(this);

        return this;
    },

    /* Init */
    init() {
        if (!this.config.init) return this;
        // this.setupTooltips();

        /* init images */
        this.image = ImageClient(
            `${this.selector} [data-component="ImageRxjs"][data-type="${this.config.type.image}"]`,
            {
                ...this.config.image
            }
        );
        this.secondaryImage = ImageClient(
            `${this.selector} [data-component="ImageRxjs"][data-type="${this.config.type.secondaryImage}"]`,
            {
                ...this.config.secondaryImage
            }
        );
        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();

        /* start */
        this.start();

        return this;
    }
};

// Exports
module.exports = prototype;
